import { useRef, useState, useCallback } from 'react';

// Lightweight 3D tilt hook for premium card hover interactions.
// Applies perspective rotation based on cursor position within the element.
// Disabled automatically for touch/coarse pointers via the caller checking matchMedia if needed.
export function useTilt(maxTilt = 7) {
  const ref = useRef(null);
  const [style, setStyle] = useState({ transform: 'perspective(900px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)' });

  const onMouseMove = useCallback((e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    setStyle({
      transform: `perspective(900px) rotateX(${(-py * maxTilt).toFixed(2)}deg) rotateY(${(px * maxTilt).toFixed(2)}deg) scale3d(1.015,1.015,1.015)`,
    });
  }, [maxTilt]);

  const onMouseLeave = useCallback(() => {
    setStyle({ transform: 'perspective(900px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)' });
  }, []);

  return { ref, style, onMouseMove, onMouseLeave };
}
